import { 
    CreateReferralSettingDto, 
    DeleteReferralSettingDto,
    EditReferralSettingDto,
    GetReferralSettingDto, 
    MessageResponseDto, 
    UtilityReferralSettingApiFp,
    UtilReferralSettingControllerGet200Response,
} from "@api/api";
import { apiConfig } from "@factory/query/config";
import { QueryKey } from "@factory/query/query-key.enum";

export type GetResponseReferralSettingModel = UtilReferralSettingControllerGet200Response;
export type GetReferralSettingModel = GetReferralSettingDto;
export type MutateResponseReferralSettingModel = MessageResponseDto;
export type CreateReferralSettingModel = CreateReferralSettingDto;
export type UpdateReferralSettingModel = EditReferralSettingDto;
export type DeleteReferralSettingModel = DeleteReferralSettingDto;

export const apiReferralSettingFp = UtilityReferralSettingApiFp(apiConfig);
export const getReferralSettingController = apiReferralSettingFp.utilReferralSettingControllerGet;
export const createReferralSettingController = apiReferralSettingFp.utilReferralSettingControllerCreate;
export const updateReferralSettingController = apiReferralSettingFp.utilReferralSettingControllerEdit;
export const deleteReferralSettingController = apiReferralSettingFp.utilReferralSettingControllerDelete;

export const QueryKeyReferralSetting = QueryKey.ReferralSetting;
